// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"ba563bc7","359":"a532f010","399":"ab294296","447":"2c687dbc","451":"71e977c4","455":"acf7ab9c","497":"7cec968b","723":"dd098f0c","821":"4dc13caf"}[chunkId] + ".chunk.js";
};